import { auth } from '../../api'

export const AuthStoreService = () => {
  return auth()
}
